<template>
    <SccLink :class="mainClass" :to="fullPath">
        <span :class="rankClass">{{ rank || '#' }}</span>
        <span class="scc-subgame-rank-block__name-container">
            <p class="scc-subgame-rank-block__name">{{ name }}</p>
        </span>
        <div class="scc-subgame-rank-block__spacer"></div>
        <span class="scc-subgame-rank-block__amount-container">
            <p class="scc-subgame-rank-block__amount">{{ amount }} loten</p>
        </span>
        <template v-if="showLink && fullPath">
            <div class="scc-subgame-rank-block__spacer"></div>
            <span class="scc-subgame-rank-block__link-container">
                <SccLink class="scc-subgame-rank-block__link" :to="fullPath">Loten kopen <arrow-right /></SccLink>
            </span>
        </template>
    </SccLink>
</template>

<script>
import './subgame-rank-block.scss';
import arrowRight from '../../assets/icons/arrow-right.vue';

export default {
    name: 'SubgameRankBlock',
    components: { arrowRight },
    props: {
        rank: {
            type: Number,
        },
        name: {
            type: String,
            default: 'Club name',
        },
        amount: {
            type: Number,
            default: 0,
        },
        slug: {
            type: String,
        },
        path: {
            type: String,
        },
        active: {
            type: Boolean,
            default: false,
        },
        customClass: {
            type: String,
            default: '',
        },
        showLink: {
            type: Boolean,
            default: false,
        },
        hasColumns: {
            type: Boolean,
            default: false,
        },
        keepLeft: {
            type: Boolean,
            default: false,
        },
        showCurrentClub: {
            type: Boolean,
            default: false,
        },
        isMain: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        mainClass() {
            const baseClass = 'scc-subgame-rank-block';

            return `${baseClass} ${this.customClass ? this.customClass : ''} ${
                this.fullPath === '' ? 'scc-subgame-rank-block--no-link' : ''
            } ${
                this.hasColumns
                    ? this.keepLeft
                        ? 'scc-subgame-rank-block--left'
                        : 'scc-subgame-rank-block--right'
                    : ''
            }`;
        },
        rankClass() {
            const baseClass = 'scc-subgame-rank-block__ranking';

            return `${baseClass}${this.active ? ' scc-subgame-rank-block__ranking--active' : ''}${
                this.showCurrentClub ? ' scc-subgame-rank-block__ranking--show-current' : ''
            }${this.isMain ? ' scc-subgame-rank-block__ranking--is-main' : ''}`;
        },
        fullPath() {
            if (!this.showLink) return '';
            if (!this.path || !this.slug) return null;
            return `/${this.path}/${this.slug}`;
        },
    },
};
</script>
